const Administracion = () => {
  return (
    <div className="text-center mt-10">
      <h2 className="text-2xl font-semibold text-blue-700">Vista: Administración</h2>
      <p className="mt-4 text-gray-600">Aquí podrás gestionar usuarios, permisos, y configuraciones generales.</p>
    </div>
  );
};

export default Administracion;
